import type { CmmdProjectAgentMember } from "@cmmd-forge/contracts";

const PROVIDER_LOCKED_AGENT_KINDS = ["codex", "cursor", "claude"] as const;

type ProviderLockedAgentKind = (typeof PROVIDER_LOCKED_AGENT_KINDS)[number];

const PROVIDER_LOCKED_DISPLAY_NAMES = {
  codex: "Codex",
  cursor: "Cursor",
  claude: "Claude",
} as const satisfies Record<ProviderLockedAgentKind, string>;

export function isProviderLockedAgentKind(
  kind: CmmdProjectAgentMember["agentKind"],
): kind is ProviderLockedAgentKind {
  return (PROVIDER_LOCKED_AGENT_KINDS as readonly string[]).includes(kind);
}

export function providerLockedDisplayName(kind: ProviderLockedAgentKind): string {
  return PROVIDER_LOCKED_DISPLAY_NAMES[kind];
}

export function displayNameForCreate(
  kind: CmmdProjectAgentMember["agentKind"],
  enteredName: string,
): string {
  return isProviderLockedAgentKind(kind) ? providerLockedDisplayName(kind) : enteredName.trim();
}

export function canRenameAgentMember(kind: CmmdProjectAgentMember["agentKind"]): boolean {
  return !isProviderLockedAgentKind(kind);
}
